import { Spinner } from "@heroui/react";

const loadingPage = () => {
    return <div>
        <Spinner /></div>;
};

export default loadingPage;